<template>
  <div class="suitComponent" :class="{ noColor }">
    <div class="suitContainer">
      <div class="suitOutline tl"><fa :icon="icon" :size="size" /></div>
      <div class="suitOutline tr"><fa :icon="icon" :size="size" /></div>
      <div class="suitOutline bl"><fa :icon="icon" :size="size" /></div>
      <div class="suitOutline br"><fa :icon="icon" :size="size" /></div>
      <div class="suit">
        <fa :icon="icon" :class="suit" :size="size" :style="style" />
      </div>
    </div>
  </div>
</template>

<script>
const colors = {
  h: "#ff0000",
  d: "#0000ff",
  c: "#008800",
  s: "#000000",
};

export default {
  name: "Suit",
  props: {
    suit: { type: String, required: true },
    noColor: { type: Boolean, default: false },
    size: { type: String, default: "sm" },
  },
  computed: {
    icon() {
      const icons = {
        h: "heart",
        s: "spade",
        d: "diamond",
        c: "club",
      };
      return icons[this.suit];
    },
    style() {
      return this.noColor ? {} : { color: colors[this.suit] };
    },
  },
};
</script>

<style lang="scss" scoped>
.h,
.d {
  color: red;
}
.s,
.c {
  color: black;
}
.noColor {
  .h,
  .d,
  .s,
  .c {
    color: inherit;
  }
}
.suitContainer {
  position: relative;
}
.suitOutline {
  color: white;
}
.suit {
  position: relative;
}
.suitOutline {
  position: absolute;
  &.tl {
    top: -1px;
    left: -1px;
  }
  &.tr {
    top: -1px;
    left: 1px;
  }
  &.bl {
    top: 1px;
    left: -1px;
  }
  &.br {
    top: 1px;
    left: 1px;
  }
}
.suitOutline {
  /*transform: scale(1);*/
  filter: blur(0.5px);
}
</style>
